import React, {useEffect, useState } from "react";
import { FormSelect } from "shards-react";
import baseUrl from "config/baseUrl";
import useToken from "shared/hook/useToken";

const SelectUser = (props) => {
  const { token } = useToken();
  const { placeholder, name, onChange, value, invalid, typeId, onBlur,disabled } = props;
  const [dateUser, setDateUser] = useState(null);
  useEffect(() => {
    const axios = require("axios").default;
    var data = JSON.stringify({
        params: {
            createDate: "2022-01-01:2022-12-30",
            userType: typeId
        },
        show: 30,
        page: 1,
        orderBy: "userId",
        orderType: "ASC"
    });

    var config = {
      method: 'post',
      url: `${baseUrl}/v1/user/users`,
      headers: { 
        'Authorization': `Bearer ${token}`, 
        'Content-Type': 'application/json'
      },
      data : data
    };
    axios(config).then(function (response) {
        setDateUser(response.data);
    })
    .catch(function (error) {
        console.log(error);
    });
  }, [typeId, value]);

  return (
    <FormSelect
      placeholder={placeholder}
      name={name}
      onChange={onChange}
      value={value}
      invalid={invalid}
      onBlur={onBlur}
      disabled={disabled}
    >
      <option value="0">-เลือก-</option>
      {dateUser != null && dateUser.users.length > 0 &&
        dateUser.users.map((item, key) => (
          <option key={key} value={item.userId} title={`${item.firstName} - ${item.lastName}`}>
            {`${item.firstName} - ${item.lastName}`}
          </option>
        ))}
    </FormSelect>
  );
};
export default SelectUser;
